import { render } from "./InstructorLogbook.vue?vue&type=template&id=ba388530&scoped=true"
import script from "./InstructorLogbook.vue?vue&type=script&lang=js"
export * from "./InstructorLogbook.vue?vue&type=script&lang=js"

import "./InstructorLogbook.vue?vue&type=style&index=0&id=ba388530&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba388530"]])

export default __exports__